<template>
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.69303 17.5V15.8333C3.69303 14.9493 4.04422 14.1014 4.66935 13.4763C5.29447 12.8512 6.14231 12.5 7.02637 12.5H13.693C14.5771 12.5 15.4249 12.8512 16.0501 13.4763C16.6752 14.1014 17.0264 14.9493 17.0264 15.8333V17.5"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M10.359 9.16667C8.5181 9.16667 7.02572 7.67428 7.02572 5.83333C7.02572 3.99238 8.5181 2.5 10.359 2.5C12.2 2.5 13.6924 3.99238 13.6924 5.83333C13.6924 7.67428 12.2 9.16667 10.359 9.16667Z"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

</template>